import React, { useEffect } from "react";
import History from "./History/History";

function OrderHistory() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when component mounts
  }, []);
  return (
    <>
      <History />
    </>
  );
}

export default OrderHistory;
